import Pips from './Pips/Pips';
import PipsItem from './PipsItem/PipsItem';
import PipsInner from './PipsInner/PipsInner';
export default Pips;
export { PipsItem, PipsInner };
